<template>
  <div class="timeline-event-historyentry">
    <div class="timeline-event-historyentry__title">
      {{ title }}
    </div>
    <div class="timeline-event-historyentry__subtitle">
      OBSERVACIONES
    </div>
    <div class="timeline-event-historyentry__text" v-html="text">
    </div>
    <timeline-event-documents :documents="entity.documents">
    </timeline-event-documents>
  </div>
</template>

<script>
export default {
  props: ['event', 'entity', 'doctor_names'],
  computed: {
    text() {
      return this.entity.notes;
    },
    title() {
      if (!this.entity) return '';


      const names = this.entity.treatments.map(x => x.full_name);
      return names.join(' ');
    },
    ...mapGetters(['msgwindow', 'errorwindow', 'clinic'])
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="scss">
.timeline-event-historyentry {
  &__title {
    margin-top: 15px;
    font-size: 15px;
    font-weight: 700;
  }

  &__subtitle {
    margin-top: 15px;
    font-size: 12px;
    font-weight: 500;
  }

  &__text {
    font-size: 14px;
    font-weight: 500;

    p {
      margin-bottom: 8px;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
